import React from 'react';
import { Form } from 'tea-component';
import { useIntl } from 'umi';
import SvgIcon from '@home/components/SvgIcon';

export type SummaryNameFormProps = {
  value: string;
  onChange: (value: string) => void;
};

export default function SummaryNameForm({
  value,
  onChange,
}: SummaryNameFormProps) {
  const { formatMessage } = useIntl();

  return (
    <Form.Item
      required
      showStatusIcon={false}
      label={formatMessage({ id: 'Summary Name' })}
    >
      <div className="dbo-summary-name-input-wrapper">
        <input
          className="dbo-summary-name-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={formatMessage({ id: 'Please enter a name for report' })}
        />
        {value && (
          <SvgIcon
            type="clear-icon"
            className="dbo-summary-name-clear-icon"
            onClick={() => onChange('')}
          />
        )}
      </div>
    </Form.Item>
  );
}
